
var ff = 0; var timerff = setInterval(function () {
  if (jQuery('.flickity-button').length) {


    jQuery('.mobile-slide-image').eq(0).addClass('current-image');
    var images = jQuery('.mobile-slide-image');

    for (var i = 0; i < images.length; i++) {
      jQuery('.content-slideshow').eq(0).before(images.eq(i));
      jQuery('.contentslide__heading').eq(i).before(jQuery('<div class="slide-counter" style="display: none">' + (i + 1) + '/' + images.length + '</div>'))
    }
    jQuery('.content-slideshow .flickity-button').eq(0).before(jQuery('<span class="next-title previous"></span>'));
    jQuery('.content-slideshow .flickity-button').eq(1).before(jQuery('<span class="next-title"></span>'));

    var nextText = "t";
    setInterval(function () {

      var prev = jQuery('.content-slideshow .slideshow__cell.is-selected').prev();
      var next = jQuery('.content-slideshow .slideshow__cell.is-selected').next();

      jQuery('.mobile-slide-image').removeClass('current-image');
      jQuery('.mobile-slide-image').eq(jQuery('.content-slideshow .slideshow__cell.is-selected').attr('data-index')).addClass('current-image');
      if (jQuery('.content-slideshow .slideshow__cell.is-selected').attr('data-index') == 0) {
        jQuery('span.next-title.previous').hide();
        jQuery('.content-slideshow button.flickity-button.flickity-prev-next-button.previous').hide()
      }
      else {
        jQuery('span.next-title.previous').show();
        jQuery('.content-slideshow button.flickity-button.flickity-prev-next-button.previous').show();
      }

      if (jQuery('.content-slideshow .slideshow__cell.is-selected').attr('data-index') == (jQuery('.content-slideshow .slideshow__cell').length - 1)) {
        jQuery('span.next-title').eq(1).hide();
        jQuery('.content-slideshow button.flickity-button.flickity-prev-next-button.next').hide()
      }
      else {
        jQuery('span.next-title').eq(1).show();
        jQuery('.content-slideshow button.flickity-button.flickity-prev-next-button.next').show()
      }
      if (nextText != prev.find('h4.contentslide__heading').eq(0).text().trim()) {


        if (prev.length == 0) {
          prev = jQuery('.content-slideshow .slideshow__cell').eq(jQuery('.content-slideshow .slideshow__cell').length - 1);
        }
        if (next.length == 0) {
          next = jQuery('.content-slideshow .slideshow__cell').eq(0);
        }
        nextText = prev.find('h4.contentslide__heading').eq(0).text().trim();
        jQuery('.next-title').eq(0).html(prev.find('h4.contentslide__heading').eq(0).text().trim());
        jQuery('.next-title').eq(1).html(next.find('h4.contentslide__heading').eq(0).text().trim());

      }

    }, 500);




    clearInterval(timerff);
  } if (ff > 200) { clearInterval(timerff); } ff++;
}, 50);

/* LARGE SLIDER FIX 2 */
window.addEventListener('load', () => {
  const _contentSlide = document.querySelectorAll('.content-slideshow .slideshow__cell');
  if (_contentSlide) {
    const _contentSlideContainer = document.querySelector('.content-slideshow .flickity-viewport');

    _contentSlide.forEach((slide, index) => {
      if (index === 0) {
        const slideContentWrap = slide.querySelector('.slideshow__content-wrapper');
        let slideHeight = slide.getBoundingClientRect().height;
        let newHeight;
        if (window.innerWidth <= 960) {
          newHeight = slideHeight + 5;
        } else {
          newHeight = slideHeight + 200;
        }
        _contentSlideContainer.style.height = `${newHeight}px`
        slideContentWrap.style.height = `${newHeight}px`
      }
    })
  }
})
